import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { getBlogBySlug } from "../data/site";
import { staggerDelay } from "../lib/stagger";

export default function BlogDetail() {
  const { slug } = useParams<{ slug: string }>();
  const post = slug ? getBlogBySlug(slug) : undefined;

  if (!post) {
    return (
      <div className="flex flex-col items-center gap-6 py-32 text-center">
        <p className="text-lg text-muted-foreground">Post not found.</p>
        <Link
          to="/blogs"
          className="inline-flex items-center gap-1.5 text-sm text-primary underline underline-offset-4 transition-colors hover:text-foreground"
        >
          <ArrowLeft className="h-3 w-3" /> Back to blog
        </Link>
      </div>
    );
  }

  return (
    <div className="relative flex flex-col gap-12 py-20 md:py-28">
      <div
        className="pointer-events-none absolute -top-32 left-1/2 h-64 w-[600px] -translate-x-1/2 rounded-full opacity-30 blur-[100px]"
        style={{ background: "oklch(0.5 0.18 260 / 40%)" }}
      />

      <Link
        to="/blogs"
        className="stagger-in inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-primary"
        style={{ animationDelay: staggerDelay(0) }}
      >
        <ArrowLeft className="h-3.5 w-3.5" /> Blog
      </Link>

      <div className="flex flex-col gap-5">
        <h1
          className="stagger-in font-display text-4xl font-bold tracking-tight sm:text-5xl"
          style={{ animationDelay: staggerDelay(1) }}
        >
          {post.title}
        </h1>
      </div>

      {post.tags && post.tags.length > 0 ? (
        <div
          className="stagger-in flex flex-wrap gap-2.5"
          style={{ animationDelay: staggerDelay(2) }}
        >
          {post.tags.map((t) => (
            <span
              key={t}
              className="rounded-full border border-border bg-secondary/30 px-4 py-1.5 text-sm text-foreground/80"
            >
              {t}
            </span>
          ))}
        </div>
      ) : null}

      <p
        className="stagger-in max-w-2xl text-base leading-relaxed text-muted-foreground/80"
        style={{ animationDelay: staggerDelay(3) }}
      >
        {post.summary}
      </p>
    </div>
  );
}
